if (!customElements.get('desktop-search-drawer')) {
  class DesktopSearchDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.triggers = document.querySelectorAll('#header .trigger-search');
      this.closeButton = this.querySelector('.search-drawer-close');
      this.input = this.querySelector('input[name="q"]');
      this.searchForm = this.querySelector('search-form');
      this.activeTrigger = this.triggers[0] || null;

      this.onKeyDown = this.handleKeyDown.bind(this);
      this.onOverlayClick = this.handleOverlayClick.bind(this);

      this.triggers.forEach((trigger) => {
        trigger.setAttribute('aria-controls', 'desktop-search-drawer');
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.activeTrigger = trigger;
          if (this.isOpen()) this.close();
          else this.open();
        });
      });

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }
    }

    setTriggersExpanded(expanded) {
      this.triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    closeOtherMenus() {
      var desktopMenu = document.querySelector('desktop-menu-drawer');
      if (desktopMenu && typeof desktopMenu.close === 'function' && desktopMenu.isOpen && desktopMenu.isOpen()) {
        desktopMenu.close();
      }

      var mobileMenu = document.getElementById('mobile-menu');
      if (mobileMenu && mobileMenu.classList.contains('open') && typeof mobileMenu.close === 'function') {
        mobileMenu.close();
      }
    }

    open() {
      this.closeOtherMenus();

      this.classList.add('open');
      this.removeAttribute('aria-hidden');
      document.documentElement.classList.add('desktop-search-drawer-open');
      this.setTriggersExpanded(true);
      $s.showOverlay();
      document.addEventListener('keydown', this.onKeyDown);
      var overlay = document.querySelector('#overlay');
      if (overlay) overlay.addEventListener('click', this.onOverlayClick);
      setTimeout(() => {
        $s.trapFocus(this);
        if (this.input) {
          this.input.focus();
          try {
            this.input.selectionStart = this.input.selectionEnd = this.input.value.length;
          } catch (e) {}
        }
      }, 100);
    }

    close() {
      this.classList.remove('open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('desktop-search-drawer-open');
      this.setTriggersExpanded(false);
      $s.removeTrapFocus();
      $s.hideOverlay();
      document.removeEventListener('keydown', this.onKeyDown);
      var overlay = document.querySelector('#overlay');
      if (overlay) overlay.removeEventListener('click', this.onOverlayClick);
      if (this.searchForm && typeof this.searchForm.clearResults === 'function') {
        this.searchForm.clearResults();
      }
      if (this.activeTrigger) this.activeTrigger.focus();
    }

    isOpen() {
      return this.classList.contains('open');
    }

    handleKeyDown(e) {
      if (e.key === 'Escape' && this.isOpen()) {
        e.preventDefault();
        this.close();
      }
    }

    handleOverlayClick() {
      if (this.isOpen()) this.close();
    }
  }

  customElements.define('desktop-search-drawer', DesktopSearchDrawer);
}
